import React, { useState } from "react";
import { useRouter } from "next/router";
import Lottie from "lottie-react";
import portfolioresult from "../../../../../public/lottie/portfolioresult.json.json";
import { useTranslation } from "next-i18next";
import Title from "components/common/title";
import { MainPortfolio } from "components/templates/common/Portfolio/Main";
import { TYPO } from "styles/Typo";
import Icon, { ICONS } from "components/common/Icons";
import PortfolioSettingModal from "components/modals/PortfolioSettingModal";
import {
  usePortfolioDispatch,
  usePortfolioState,
} from "contexts/PortfolioContext";
import CustomToast from "components/atoms/CustomToast";
import { PortfolioMainSkeleton } from "components/skeleton/portfolio";

const Button = ({
  text,
  icon,
  clickHandler,
}: {
  text: string;
  icon: string;
  clickHandler: any;
}) => {
  return (
    <div
      className="cursor-pointer flex gap-1 items-center bg-gray15 rounded-[12px] px-4 py-[11px] w-full justify-center h-[48px]"
      onClick={clickHandler}
    >
      <span className={`${TYPO.TYPO6_MD} text-gray60 shrink-0`}>{text}</span>
      <div className="shrink-0">
        <Icon name={icon} fill="gray60" width={16} height={16} />
      </div>
    </div>
  );
};

function Main({ userProfile, portfolios }: any) {
  const [sortOrder, setSortOrder] = useState("riskHigh");
  const router = useRouter();
  const { t } = useTranslation("portfolio");
  const [warningModal, setWarningModal] = useState(false);
  const [settingModal, setSettingModal] = useState(false);
  const state = usePortfolioState();
  const dispatch = usePortfolioDispatch();
  const baseCurrency = state.baseCurrency;

  return (
    <div
      className="flex flex-col  "
      // style={{ minHeight: "calc(100vh - (5rem + 83px))" }}
      style={{ height: "fit-content" }}
    >
      <div className="px-6 pt-6">
        <span className={`${TYPO.TYPO3_B} text-gray80`}>
          {t("myPortfolio")}
        </span>
      </div>
      {!portfolios && <PortfolioMainSkeleton />}
      {portfolios && (
        <>
          <div className="flex flex-col p-6 min-w-[360px] gap-3 ">
            {portfolios &&
              portfolios?.map((portfolio: any, idx: number) => (
                <div key={idx}>
                  <MainPortfolio
                    portfolio={portfolio}
                    portfolios={portfolios}
                    t={t}
                    idx={idx}
                  />
                </div>
              ))}
          </div>
          <div className="flex gap-[10px] w-full px-6">
            <Button
              text={t("createPortfolio")}
              clickHandler={() => {
                if (userProfile && userProfile.portfolios.length >= 3) {
                  setWarningModal(true);
                  return;
                }
                router.push("/portfolio/new");
              }}
              icon={ICONS.ADD}
            />
            <Button
              text={t("settingPortfolio")}
              clickHandler={() => {
                //모달
                setSettingModal(true);
              }}
              icon={ICONS.SETTING}
            />
          </div>
          {warningModal && (
            <CustomToast
              message={t("warningCreatePortfolio")}
              isVisible={warningModal}
              onClose={() => setWarningModal(false)}
              isSuccess={false}
              width={330}
            />
          )}
          {settingModal && (
            <PortfolioSettingModal
              setModalOpen={setSettingModal}
              isModalOpen={settingModal}
              toggleDispatch={dispatch}
              toggleState={baseCurrency}
            />
          )}
        </>
      )}
    </div>
  );
}

export default Main;
